module.exports = __webpack_public_path__ + "img/deanie.5de523af.jpg";